export function beep(
    duration: number = 200,
    frequency: number = 440,
    volume: number = 1,
    type: OscillatorType = "sine",
): void {
    const audioCtx = new (window.AudioContext ||
        (window as any).webkitAudioContext)();
    const oscillator = audioCtx.createOscillator();
    const gainNode = audioCtx.createGain();

    oscillator.connect(gainNode);
    gainNode.connect(audioCtx.destination);

    gainNode.gain.value = volume;
    oscillator.frequency.value = frequency;
    oscillator.type = type;

    oscillator.start();
    setTimeout(() => {
        oscillator.stop();
        audioCtx.close();
    }, duration);
}

export function playCallTerminatedTone(
    repeats: number = 3,
    interval: number = 600,
) {
    let count = 0;
    const audioCtx = new (window.AudioContext ||
        (window as any).webkitAudioContext)();

    const playOneTone = () => {
        const oscillator = audioCtx.createOscillator();
        const gainNode = audioCtx.createGain();

        oscillator.connect(gainNode);
        gainNode.connect(audioCtx.destination);

        oscillator.type = "sine";
        oscillator.frequency.setValueAtTime(600, audioCtx.currentTime); // start higher
        oscillator.frequency.exponentialRampToValueAtTime(
            200,
            audioCtx.currentTime + 0.4,
        );

        gainNode.gain.setValueAtTime(1.5, audioCtx.currentTime); // louder than before
        gainNode.gain.exponentialRampToValueAtTime(
            0.001,
            audioCtx.currentTime + 0.4,
        );

        oscillator.start();
        oscillator.stop(audioCtx.currentTime + 0.4);
    };

    const intervalId = setInterval(() => {
        playOneTone();
        count++;
        if (count >= repeats) {
            clearInterval(intervalId);
            // close AudioContext after last tone
            setTimeout(() => audioCtx.close(), 500);
        }
    }, interval);
}
